import Cookies from "js-cookie";
import React from "react";
import { useWhoAmI } from "../user/useWhoAmI";

/**
 * Restores k in url and redirects to relevant page
 */
export function useRestoreConcernAfterHardcodedLinkClick() {
  const concernInCookie = useRememberConcernInCookie(); // note that there is no guarantee this is the correct concern
  const { whoAmI } = useWhoAmI();

  React.useEffect(() => {
    if (window.cvpIdConcern) return;
    if (!isComingFromVismaConnectHardcodedLink()) return;

    const hasProfileInConcernFromCookie = !!whoAmI.hasProfileInConcerns.find(
      (k) => k.toString() === concernInCookie
    );

    const urlToGoTo = getUrlToGoToAfterHardcodedLinkClick(
      concernInCookie,
      hasProfileInConcernFromCookie
    );

    console.log("useRestoreConcernAfterHardcodedLinkClick", {
      concernInCookie,
      hasProfileInConcernFromCookie,
      urlToGoTo,
    });

    window.location.href = urlToGoTo;
  }, []);
}

// hardcoded link set in visma developer portal
function getUrlToGoToAfterHardcodedLinkClick(
  concernInCookie: string | undefined | null,
  hasProfileInConcernFromCookie: boolean
) {
  // there is only one known case we end up here:
  // 1. user has clicked the link the in create-visma-account email and is at this point logged in to visma-connect

  if (!concernInCookie) {
    // user clicked the link in a different browser
    // we don't know which concern they started out in

    // show simple message saying creation was successful
    return `${window.location.origin}/created`;
  }

  if (!hasProfileInConcernFromCookie) {
    // no profile was auto connected, redirect to /profile that shows the form to create/connect profile
    return `${window.location.origin}/profile?k=${concernInCookie}`;
  }

  // a profile was auto connected
  return `${window.location.origin}?k=${concernInCookie}`;
}

function isComingFromVismaConnectHardcodedLink() {
  const urlParams = new URLSearchParams(window.location.search);
  return !!urlParams.get("VismaConnectInitiateLoginRedirect");
}

function useRememberConcernInCookie() {
  const urlParams = new URLSearchParams(window.location.search);
  const k = urlParams.get("k");
  if (k) {
    Cookies.set("k", k, { path: "/" });
  }

  return Cookies.get("k");
}
